export const GENERATE_COUNT_JOB_REPORTS_ACTION = "generate_counting_job_reports";
export const FINALIZE_RESULT_COUNT_ACTION = "finalize_counting_results";
export const PUSH_PARTNUM_COUNTS_TO_DMS_ACTION = "push_partnum_counts_to_dms";
export const JOB_ACTION_LIST = "jobActionList";

